export default {"src":"/_next/static/media/29-icon.ec651df4.svg","height":37,"width":46,"blurWidth":0,"blurHeight":0};